













































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as service from '@/services/therapy';
import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import { Watch } from 'vue-property-decorator';
import { convertCharacters } from '@/helpers/convertCharacters';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { TerapiaListItemDTO, FiltroTerapiaParmDTO } from '../../../interfaces/therapy';
import { ResultPagDTO, PaginationSyncDTO } from '../../../interfaces/base-dto';
import TherapyForm from '../../../components/therapy/therapy-form.vue';
import { dateFormat } from '../../../helpers/dateFormat';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    UiAutocompleClientsSubsidiaries,
    TherapyForm,
  },
})
export default class Therapy extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public pagina: ResultPagDTO<TerapiaListItemDTO> = new ResultPagDTO<TerapiaListItemDTO>();
  public items: TerapiaListItemDTO[] = [];
  public id: Number = null;

  public filtros: FiltroTerapiaParmDTO = new FiltroTerapiaParmDTO();
  private unidade: any = {};

  public headers: any = [
    { text: 'Código', value: 'codigo', sortable: false, },
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'Usuário alteração', value: 'alteradoPor', sortable: false },
    { text: 'Data', value: 'ultimaAlteracao', sortable: false },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];

  private pagination: PaginationSyncDTO = new PaginationSyncDTO();

  private mounted(): void {
    this.pesquisar();
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  private onChangeSearch() {
    if (this.loading) {      
      return;
    }
    this.pesquisar();
  }

  private pesquisar() {
    this.items = [];
    this.loading = true;
    this.error = false;
    this.filtros.idUnidade = this.unidade ? this.unidade.id : null;
    this.filtros.page = this.pagination.page;
    this.filtros.size = this.pagination.rowsPerPage;
    this.addSubsc(
      service.getTherapies(this.filtros).subscribe(
        (result) => {
          this.loading = false;
          this.pagina = result;
          this.items = this.pagina.content;
          PaginationSyncDTO.update(this.pagination, result);
        },
        () => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  private newItem(): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = null;
  }

  private onEditItem(item): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = item.id;
  }

  private closeForm(): void {
    this.formOpen = false;
    this.id = null;
  }

  private saveItem(): void {
    this.closeForm();
    this.pesquisar();
  }
}
